/**
 * "/refund-policy" — public Refund & Cancellation Policy, reachable logged in or out.
 * Linked from the landing footer and the sign-up consent.
 */
import { createFileRoute } from '@tanstack/react-router';
import { REFUND_POLICY } from '@finmin/ui';
import { LegalPage } from '@/features/legal/legal-page';

export const Route = createFileRoute('/refund-policy')({
  component: () => <LegalPage doc={REFUND_POLICY} />,
});
